import { render, staticRenderFns } from "./products-combo-edit.vue?vue&type=template&id=898007a2&"
import script from "./products-combo-edit.vue?vue&type=script&lang=js&"
export * from "./products-combo-edit.vue?vue&type=script&lang=js&"
import style0 from "./products-combo-edit.vue?vue&type=style&index=0&id=898007a2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('898007a2')) {
      api.createRecord('898007a2', component.options)
    } else {
      api.reload('898007a2', component.options)
    }
    module.hot.accept("./products-combo-edit.vue?vue&type=template&id=898007a2&", function () {
      api.rerender('898007a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stores/products-combo-edit.vue"
export default component.exports